import {createContext, Dispatch, SetStateAction, useState} from 'react';

interface IGContext{
    v:number;
    setV?: Dispatch<SetStateAction<number>>;
}

const defaultValue = {
    v: 133
}

export const GContext = createContext<IGContext>(defaultValue);

export const GProvider = ({children})=>{
    const [v, setV] = useState(123);
    return (
        <GContext.Provider value={{v, setV}}>
            {children}
        </GContext.Provider>
    )
}
